import React from "react";
import { Route } from "react-router";

import Organizations from "./Organizations";
import Competitions from "../Competitions/Competitions";
import Seasons from "../Seasons/Seasons";
import VideoProviderSettings from "../VideoProviderSettings/VideoProviderSettings";

const OrganizationRoutes = (props) => {
  const { title, updateState, sport } = props;
  return (
    <>
      <Route
        exact
        path={"/organizations"}
        render={(props) => <Organizations {...props} sport={sport} updateState={updateState} title={title} />}
      />
      <Route
        exact
        path={"/organizations/:organizationId/competitions"}
        render={(props) => <Competitions {...props} sport={sport} updateState={updateState} title={title} />}
      />
      <Route
        exact
        path={"/organizations/:organizationId/competitions/:competitionId/seasons"}
        render={(props) => <Seasons {...props} sport={sport} updateState={updateState} title={title} />}
      />
      <Route
        exact
        path={"/organizations/:organizationId/competitions/:competitionId/video-provider-settings"}
        render={(props) => (
          <VideoProviderSettings
            {...props}
            sport={sport}
            updateState={updateState}
            title={title}
            entityType="competition"
          />
        )}
      />
      <Route
        exact
        path={"/organizations/:organizationId/competitions/:competitionId/seasons/:seasonId/video-provider-settings"}
        render={(props) => (
          <VideoProviderSettings {...props} sport={sport} updateState={updateState} title={title} entityType="season" />
        )}
      />
    </>
  );
};

export default OrganizationRoutes;
